<template>
    <div class="container-fluid" id="dashboard-page">
        <div class="col-md-12">
            <h1>{{greeting}}</h1>
        </div>
        <div class="col-xl-10 col-lg-12">
            <div class="row">
                <div class="col-md-3 col-sm-6 dash-card">
                    <h2>Search Auctions</h2>
                    <div>
                        <strong>{{listingCount}}</strong> listings today
                    </div>
                    <a href="/auctions" class="btn btn-primary">
                        Search
                    </a>
                </div>
                <div class="col-md-3 col-sm-6 dash-card">
                    <h2>Recommended List</h2>
                    <div>
                        <strong>{{recommendCount}}</strong>
                         cars selected for you
                        <br /><br />
                    </div>
                    <a href="/recommended" class="btn btn-primary">
                        View
                    </a>
                </div>
                <div class="col-md-3 col-sm-6 dash-card">
                    <h2>Review your bids</h2>
                    <div>
                        <strong>{{ bidCount }}</strong>
                        <template v-if="bidCount === 1">bid</template>
                        <template v-else>bids</template>
                        placed today<br /><br />
                    </div>
                    <a href="/user-bid" class="btn btn-primary">
                        View
                    </a>
                </div>
                <div class="col-md-3 col-sm-6 dash-card">
                    <h2>Request a car</h2>
                    <div v-if="loggedInUser && loggedInUser.sales_rep">
                        {{loggedInUser.sales_rep.name}}
                        <template v-if="loggedInUser.sales_rep.profile && loggedInUser.sales_rep.profile.mobile">
                            {{loggedInUser.sales_rep.profile.mobile}}
                        </template>
                        <br />
                        <a v-if="loggedInUser.sales_rep.email" :href="`mailto:${loggedInUser.sales_rep.email}`">
                            {{loggedInUser.sales_rep.email}}
                        </a>
                    </div>
                    <a href="/request-vehicle" class="btn btn-primary">
                        Request
                    </a>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="container full-width">
                <div class="container-table">
                    <b-form-checkbox
                        class="hide_prices"
                        :value="1"
                        v-model="hidePrices">
                        Hide Prices
                    </b-form-checkbox>
                </div>
            </div>
            <publicStock :disableHead="true" :hide-prices="hide_stock_prices"/>
        </div>
    </div>
</template>
<script>
    import publicStock from './VehicleStock/PublicStock'
    export default {
        props: [
            'props'
        ],
        created() {
        },
        components: {
            publicStock
        },
        data() {
            return {
                hide_stock_prices: this.userHasPrivilege('hide_stock_prices')
            }
        },
        computed: {
            greeting(){
                if (this.loggedInUser && this.loggedInUser.first_name) {
                    return 'Hi ' + this.loggedInUser.first_name
                }
                return 'Hi'
            },
            listingCount(){
                if (this.props && this.props.data && this.props.data.auction_total) {
                    return this.props.data.auction_total
                }
                return '0';
            },
            hidePrices: {
                get(){
                    if (this.hide_stock_prices) {
                        return 1;
                    }
                    return 0;
                },
                async set(v){
                    console.log('set hide prices', v)
                    try {
                        let res = await this.axios.patch('/users/update-hide-prices', {
                            hide_stock_prices: v ? 1 : 0
                        })
                        this.hide_stock_prices = v
                        this.loggedInUser.privileges.hide_stock_prices = v

                    } catch (e) {
                        console.warn('failed to set hide prices', e)
                    }
                }
            },
            recommendCount(){
                if (this.props && this.props.data && this.props.data.recommend_count) {
                    return this.props.data.recommend_count
                }
                return '0';
            },
            bidCount(){
                if (this.props && this.props.data && this.props.data.bid_count) {
                    return this.props.data.bid_count
                }
                return '0';
            },
        },
        methods: {
        },
    }
</script>
<style scoped lang="scss">

@import "./resources/sass/mixins";
@import "./resources/sass/variables";

.hide_prices{
    float: right;
    position: relative;
    top: 45px;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/DashboardPage.vue